

















































































import { Component, Vue } from "vue-property-decorator";
import { VesselGroup } from "@/types/vesselGroup";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
import VesselGroupsModule from "@/store/clients/VesselGroups.module";
import VesselsClient from "Clients/vessels-client";
import VesselGroupCard from "./VesselGroupCard.vue";
import CreateVesselGroupDialog from "./CreateVesselGroupDialog.vue";
import { Vessel } from "@/types/vessel";

const VesselGroups = getModule(VesselGroupsModule, store);

@Component({
  components: {
    CreateVesselGroupDialog,
    VesselGroupCard,
  },
})
export default class ManageVesselGroups extends Vue {
  nameFilter: string | null = "";
  vesselsList: Vessel[] = [];
  loading = true;
  isDialogVisible: boolean = false;
  vesselGroups: VesselGroup[] = [];

  get filteredVesselGroups(): VesselGroup[] {
    if (!this.nameFilter) return this.vesselGroups;

    const filter = this.nameFilter.toLowerCase();

    return this.vesselGroups.filter(g => g.name.toLowerCase().includes(filter));
  }

  created() {
    this.getVesselData();
  }

  onGroupAdded() {
    this.isDialogVisible = false;
    VesselGroups.EXPIRE_DATA();
    this.getVesselData();
  }

  async getVesselData() {
    this.loading = true;
    const groups = await VesselGroups.getAll();
    this.vesselGroups = groups.reverse();
    this.vesselsList = await VesselsClient.getVessels(false);
    this.loading = false;
  }

  openCreateDialog(): void {
    this.isDialogVisible = true;
  }

  onUpdate(updatedGroup: VesselGroup, index: number) {
    this.vesselGroups.splice(index, 1, updatedGroup);
  }

  onDelete(index: number) {
    this.vesselGroups.splice(index, 1);
  }
}
